import { VALID_PUNCTUATION as e } from "../constants.js";
function a(t) {
  return t.replace(new RegExp("[".concat(e, "]+"), "g"), " ").trim();
}
export { a as default };